import React, { useState } from 'react';
// Checkout uses the backend Session URL directly now, 
// so we don't need the Stripe publishable key initialized here!

const productsData = [
  { id: 1, name: "Regatta T-Shirt", price: 40, category: "Apparel", img: "RegattaTShirt.png", initialStock: 8 },
  { id: 2, name: "Skipper's Cap", price: 35, category: "Apparel", img: "RegattaSkippersCap.png", initialStock: 8 },
  { id: 3, name: "Offshore Racing Jacket", price: 280, category: "Apparel", img: "RegattaJacket.png", initialStock: 8 },
  { id: 4, name: "Stainless Steel Tumbler", price: 28, category: "Souvenirs", img: "RegattaThumbler.png", initialStock: 8 },
  { id: 5, name: "Event Poster 2026", price: 15, category: "Souvenirs", img: "poster.jpg", initialStock: 8 },
  { id: 6, name: "Official Race Burgee", price: 30, category: "Souvenirs", img: "flag.jpg", initialStock: 8 },
];

const Store = () => {
  const [filter, setFilter] = useState("All");
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const filteredProducts = filter === "All"
    ? productsData
    : productsData.filter(p => p.category === filter);

  const displayProducts = filteredProducts.map(p => {
    const cartItem = cart.find(item => item.id === p.id);
    const inCartQty = cartItem ? cartItem.quantity : 0;
    return { ...p, availableStock: p.initialStock - inCartQty };
  });

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find(item => item.id === product.id);
      const currentQty = existing ? existing.quantity : 0;
      
      // Prevent adding if stock limit reached
      if (currentQty >= product.initialStock) {
        return prev;
      }
      
      if (existing) {
        return prev.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const reduceQuantity = (id) => {
    setCart((prev) => {
      const existing = prev.find(item => item.id === id);
      if (existing && existing.quantity > 1) {
        return prev.map(item =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        );
      }
      return prev.filter(item => item.id !== id);
    });
  };

  const clearCartAndClose = () => {
    setCart([]);
    setIsCartOpen(false);
  };

  const cartTotal = cart.reduce((total, item) => total + item.price * item.quantity, 0);

  const handleCheckout = async () => {
    console.log("Creating Stripe Checkout session with items:", cart);
    
    try {
      // Call your backend to create the Checkout Session
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4242';
      const response = await fetch(`${apiUrl}/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: cart }),
      });

      const session = await response.json();

      if (session.error) {
        alert("Failed to initialize checkout: " + session.error);
        return;
      }

      // Instead of using Stripe.js local redirection, just send the browser 
      // directly to the secure Stripe Checkout URL returned by our backend!
      if (session.url) {
        window.location.href = session.url;
      } else {
        alert("No checkout session URL returned from backend.");
      }
    } catch (error) {
      console.error('Error in checkout:', error);
      alert('Checkout failed because the backend server could not be reached. Ensure the Express server is running on port 4242.');
    }
  };

  return (
    <section id="store" className="card" style={{ position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 className="section-title" style={{ margin: 0 }}>Official Merchandise</h2>

        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setIsCartOpen(!isCartOpen)}
            className="cart-btn"
          >
            Cart 🛍️ ({cart.reduce((sum, item) => sum + item.quantity, 0)})
          </button>

          {isCartOpen && (
            <div className="cart-dropdown" style={{
              position: 'absolute', right: '0', top: '100%', marginTop: '10px', width: '320px',
              backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px',
              padding: '20px', boxShadow: '0 8px 16px rgba(0,0,0,0.1)', zIndex: 100
            }}>
              <h3 style={{ marginTop: 0, borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Your Shopping Cart</h3>

              {cart.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#888', margin: '20px 0' }}>Cart is empty</p>
              ) : (
                <>
                  <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 15px 0', maxHeight: '250px', overflowY: 'auto' }}>
                    {cart.map(item => (
                      <li key={item.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontWeight: 'bold' }}>{item.name}</span>
                          <span style={{ fontSize: '14px', color: '#666' }}>{item.quantity} x ${item.price}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontWeight: 'bold', marginRight: '15px' }}>${item.price * item.quantity}</span>
                          <button onClick={() => reduceQuantity(item.id)} style={{ color: '#dc3545', border: 'none', background: 'none', cursor: 'pointer', fontSize: '24px', padding: '0 5px', fontWeight: 'bold', lineHeight: '1' }}>⬇️</button>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '18px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                    <span>Total:</span>
                    <span>${cartTotal}</span>
                  </div>
                  <button
                    onClick={handleCheckout}
                    style={{ width: '100%', marginTop: '15px' }}
                  >
                    Checkout with Stripe
                  </button>
                  <button
                    onClick={clearCartAndClose}
                    style={{ 
                      width: '100%', 
                      marginTop: '10px', 
                      backgroundColor: '#f8f9fa', 
                      color: '#dc3545', 
                      border: '1px solid #dc3545',
                      padding: '10px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    Empty Cart & Close
                  </button>
                  <p style={{ fontSize: '11px', marginTop: '15px', color: '#666', textAlign: 'center', lineHeight: '1.4' }}>
                    Payments securely processed by Stripe. <br />
                    We do not collect or store your credit card information.
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="store-filters" style={{ marginBottom: '20px' }}>
        {["All", "Apparel", "Souvenirs"].map(cat => (
          <button
            key={cat}
            className={filter === cat ? "active-filter" : ""}
            onClick={() => setFilter(cat)}
            style={{ marginRight: '10px', opacity: filter === cat ? 1 : 0.6 }}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="product-grid" style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px'
      }}>
        {displayProducts.map(product => (
          <div key={product.id} className="product-card" style={{
            border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden',
            display: 'flex', flexDirection: 'column'
          }}>
            <img
              src={`/images/${product.img}`}
              alt={product.name}
              style={{ width: '100%', height: '220px', objectFit: 'contain', backgroundColor: '#f8f9fa', padding: '15px' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://via.placeholder.com/300x180/f8f9fa/adb5bd?text=${encodeURIComponent(product.name)}`;
              }}
            />
            <div className="product-info" style={{ padding: '15px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '18px' }}>{product.name}</h3>
              <p className="price" style={{ margin: '0 0 10px 0', fontSize: '20px', fontWeight: 'bold', color: '#28a745' }}>${product.price}</p>
              <p style={{ margin: '0 0 15px 0', fontSize: '14px', fontWeight: 'bold', color: product.availableStock > 0 ? '#666' : '#dc3545' }}>
                {product.availableStock > 0 ? `In Stock: ${product.availableStock}` : 'Waiting on new stock'}
              </p>
              <div style={{ marginTop: 'auto' }}>
                <button
                  onClick={() => addToCart(product)}
                  style={{ 
                    width: '100%', 
                    opacity: product.availableStock === 0 ? 0.5 : 1,
                    cursor: product.availableStock === 0 ? 'not-allowed' : 'pointer',
                    backgroundColor: product.availableStock === 0 ? '#6c757d' : undefined
                  }}
                  disabled={product.availableStock === 0}
                >
                  {product.availableStock > 0 ? "Add to Cart" : "Out of Stock"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Store;
